var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReuse = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7501 13.5004C21.7484 15.0912 21.1157 16.6163 19.9908 17.7411C18.866 18.866 17.3409 19.4987 15.7501 19.5004H7.5001C7.30119 19.5004 7.11042 19.4214 6.96977 19.2807C6.82912 19.1401 6.7501 18.9493 6.7501 18.7504C6.7501 18.5515 6.82912 18.3607 6.96977 18.2201C7.11042 18.0794 7.30119 18.0004 7.5001 18.0004H15.7501C16.9436 18.0004 18.0882 17.5263 18.9321 16.6824C19.776 15.8385 20.2501 14.6939 20.2501 13.5004C20.2501 12.3069 19.776 11.1624 18.9321 10.3184C18.0882 9.47452 16.9436 9.00042 15.7501 9.00042H4.81041L8.03073 12.2198C8.17146 12.3605 8.25052 12.5514 8.25052 12.7504C8.25052 12.9494 8.17146 13.1403 8.03073 13.281C7.89 13.4218 7.69912 13.5008 7.5001 13.5008C7.30108 13.5008 7.11021 13.4218 6.96948 13.281L2.46948 8.78104C2.39974 8.71139 2.34442 8.62867 2.30668 8.53762C2.26894 8.44657 2.24951 8.34898 2.24951 8.25042C2.24951 8.15186 2.26894 8.05426 2.30668 7.96321C2.34442 7.87216 2.39974 7.78945 2.46948 7.71979L6.96948 3.21979C7.11021 3.07906 7.30108 3 7.5001 3C7.69912 3 7.89 3.07906 8.03073 3.21979C8.17146 3.36052 8.25052 3.55139 8.25052 3.75042C8.25052 3.94944 8.17146 4.14031 8.03073 4.28104L4.81041 7.50042H15.7501C17.3409 7.50215 18.866 8.13485 19.9908 9.2597C21.1157 10.3845 21.7484 11.9097 21.7501 13.5004Z",
    fill: "#D3D7D9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReuse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reuse.931d6340325f688bf9feaba497ed4d3b.svg";